import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import {
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { transformHourToDayHour } from '../../../../../../helper/horloge';

@Component({
  selector: 'app-p0003607-electrolyseur-statut',
  templateUrl: './p0003607-electrolyseur-statut.component.html',
  styleUrls: ['./p0003607-electrolyseur-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    TranslatePipe,
    CollapseComponent,
    IonItem,
    IonLabel,
    IonList,
  ],
})
export class P0003607ElectrolyseurStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  transformHourToDayHourLocal(value: number): string {
    return transformHourToDayHour(value, this.translateService);
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly transformHourToDayHour = transformHourToDayHour;
}
